<div class="wrapper">
    <div class="grid">
        <div class="header">
            <router-outlet name="header"></router-outlet>
        </div>
        <div id="main" class="main">
            <router-outlet></router-outlet>
        </div>
        <div class="footer">
            <!-- numer wersji prowadzi do historii zmian; ustawienia zgody stoja
                 w TEJ SAMEJ linii - osobny wiersz podnosil stopke o ~19px na
                 kazdej stronie -->
            <h3>Genealogy Cards
                <a class="version-link" [routerLink]="['/changelog']"
                    [title]="'changelog.versionLink' | t">v{{ version }}</a>
                &copy; {{ copyright }}
                <a class="consent-link" (click)="openConsent()">{{ 'main.consentSettings' | t }}</a></h3>
        </div>
    </div>
</div>